import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { getDashboardAPI } from "../../API/DashboardAPI";
import { showErrorToast } from "../../../app/utils/common/Toast";
import { DashboardState } from "../../Slices/dashboardSlice";
import { DashboardType } from "../../../dto/Dashboard.dto";

export const DashboardReducer = (
    builder: ActionReducerMapBuilder<DashboardState>
  ) => {
    builder
        .addCase(getDashboardAPI.pending, (state) => {
          state.loading = true;
        })
        .addCase(getDashboardAPI.fulfilled, (state, action: PayloadAction<DashboardType>) => {
            state.dashboardData = action.payload;
        })
        .addCase(getDashboardAPI.rejected, (state, action: PayloadAction<any>) => {
            if (action.payload) {
              showErrorToast(action.payload.message);
              state.loading = false;
            } else {
              showErrorToast("Error in get Dashboard API...");
            }
        })
  };
  